import { ErrorHandler } from '@src/components/ErrorHandler';
import { Visibility } from '@src/features/Users/components/Visibility';
import { useCurrentUser } from '@src/features/Users/hooks/useCurrentUser';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { NavMenuPrimitives } from '@uhg-abyss/web/ui/NavMenu';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

import { MenuItem } from '../MenuItem';
import { Styles as SubMenuStyles } from '../SubMenu/includes/styles';
import { Styles as UserStyles } from './includes/styles';

/**
 * UserMenu
 *
 * Provides a menu with user-related actions.
 *
 * @returns {Element}
 * @constructor
 */
export function UserMenu() {
  const { displayName, emailAddress, msid } = useCurrentUser();

  return (
    <ErrorHandler location="src/layouts/default/Header/components/Navigation/components/UserMenu/UserMenu.jsx">
      <NavMenuPrimitives.Item>
        <NavMenuPrimitives.Trigger variant="inverted">
          <MenuItem iconName="account_box" title={displayName} />
        </NavMenuPrimitives.Trigger>
        <NavMenuPrimitives.Content>
          <SubMenuStyles>
            <NavMenuPrimitives.Columns>
              <NavMenuPrimitives.Column>
                <Visibility accessor="UserInfo" disabledEnvironments={['Local', 'Development', 'Stage', 'Production']}>
                  <UserStyles>
                    <NavMenuPrimitives.Item>
                      <Text css={{ wordBreak: 'break-all' }}>
                        <Layout.Group>
                          <div style={{ whiteSpace: 'nowrap' }}>
                            <strong>MSID:</strong>
                          </div>
                          <div>{msid}</div>
                        </Layout.Group>
                      </Text>
                    </NavMenuPrimitives.Item>
                    <NavMenuPrimitives.Item>
                      <Text css={{ wordBreak: 'break-all' }}>
                        <Layout.Group>
                          <div style={{ whiteSpace: 'nowrap' }}>
                            <strong>Email:</strong>
                          </div>
                          <div>{emailAddress}</div>
                        </Layout.Group>
                      </Text>
                    </NavMenuPrimitives.Item>
                  </UserStyles>
                </Visibility>
                <NavMenuPrimitives.MenuItem href="/logout" title="Logout" />
              </NavMenuPrimitives.Column>
            </NavMenuPrimitives.Columns>
          </SubMenuStyles>
        </NavMenuPrimitives.Content>
      </NavMenuPrimitives.Item>
    </ErrorHandler>
  );
}
